<template>
  <div>
    <div class="return" v-if="pageName" @click="back">
      <img class="backImg" src="@/assets/images/back.png" alt />
    </div>
<!--     
    <div class="switch" >
    
    </div> -->
      <el-card class="box-card">
      <div style="text-align: right;">
        <el-button
            class="mb10"
            type="primary"
            size="mini"
            round
            v-if="cliDel.is_show_specified == 1 && oldId == id" 
            @click="goSon('specifiedInfoChange')"
          >指定信息修改</el-button>
          <el-button
            class="mb10"
            type="primary"
            size="mini"
            round
             v-if="cliDel.turn_status == 1 && oldId == id"
            @click="goSon('hint','turnShop','收到该客户转店')"
          >收到转店</el-button>

          <el-button
            class="mb10"
            type="primary"
            size="mini"
            round
            v-if="(cliDel.turn_status == 0||cliDel.turn_status == 2) && oldId == id" 
            @click="goSon('turnShop')"
          >客户转店</el-button>

          <!-- <el-button
            class="mb10"
            type="primary"
            size="mini"
            round 
            v-if="(userInfo.structure_id == 8 || userInfo.structure_id == 3) && oldId == id"
            @click="goSon('turnSunmeiShop')"
          >客户转双美</el-button> -->

          <el-button class="mb10" type="primary" size="mini" round v-if="oldId == id" @click="goSon('openDialog','编辑资料')">编辑资料</el-button>
          <el-button  v-if="cliDel.is_two_year_order_service && oldId == id" class="mb10" type="primary" size="mini" round @click="goSon('applyOpenDialog','消耗申请')">消耗申请</el-button>
          <el-button  v-if="cliDel.is_show_apply_progress && oldId == id" class="mb10" type="primary" size="mini"   round @click="goSon('applyProgress',cliDel)" >消耗申请进展</el-button>
      </div>
      <div class="customer_info" style="">
     <el-row>
      <!-- 左侧图片区域 -->
      <el-col :span="3">
       <img 
          :src="cliDel.sex === 1 ? require('../../assets/admin1.png') : require('../../assets/admin.png')" 
          alt="客户头像" 
          style="width: 120px; height: 120px; border-radius: 50%;"
        >
        <el-switch
          v-if="activeName == 'first'"
          v-model="value1"
          active-text="门诊信息"
          inactive-text="门店信息"
          @change="changeUser">
        </el-switch>
      </el-col>

      <!-- 右侧信息区域 -->
      <el-col :span="21" style="color: #a4a9b7"> 
        <el-row>
          <el-col :span="6" style="font-weight: bold;">
            <span class="box1">客户名称</span>：{{ cliDel.customer_name || '无' }}
          </el-col>
          <el-col :span="6" style="font-weight: bold;">
            <span class="box1">手机号码</span>：{{ cliDel.telephone || '无' }}
          </el-col>
          <el-col :span="6" style="font-weight: bold;">
            <span class="box1">客户来源</span>：{{ cliDel.source_name || '无' }}<span v-if="cliDel.source_type_id > 0">---- {{ cliDel.customer_source_name || '无' }}</span>
          </el-col>
          <el-col :span="6" style="font-weight: bold;">
            <span class="box1">创建时间</span>：{{ cliDel.create_time || '无' }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" style="font-weight: bold;">
            <span class="box1">归属门店</span>：{{ cliDel.shop_name || '无' }}
          </el-col>
         
          <el-col :span="6" style="font-weight: bold;">
            <span class="box1" >性别</span>：{{ cliDel.sex ? (cliDel.sex == 1 ? '男' : '女') : '无' }}
          </el-col>
          <el-col :span="6" style="font-weight: bold;">
            <span class="box1">会员等级</span>：{{ cliDel.membership_leve || '无' }}
          </el-col>
          <el-col :span="6" style="font-weight: bold;">
            <span class="box1">首次进店</span>：{{ cliDel.first_time || '无' }}
          </el-col>
        </el-row>
        <el-row>
           <el-col :span="6" style="font-weight: bold;">
            <span class="box1">护理师</span>：{{ cliDel.nurse_name || '无' }}
          </el-col>
          <el-col :span="6" style="font-weight: bold;">
            <span class="box1">年龄</span>：{{ cliDel.age ? `${cliDel.age} 岁(${cliDel.birthday || '无'})` : '无' }}
          </el-col>
          <el-col :span="6" style="font-weight: bold;">
            <span class="box1">客户分类</span>：{{ cliDel.class_name || '无' }}类
          </el-col>
          <el-col :span="6" style="font-weight: bold;">
            <span class="box1">二次进店</span>：{{ cliDel.second_time || '无' }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" style="font-weight: bold;">
            <span class="box1">客服</span>：{{ cliDel.operator_name || '无' }}
          </el-col>
          <el-col :span="6" style="font-weight: bold;">
            <span class="box1" >疑难级别</span>：{{ cliDel.difficulty_level ? cliDel.difficulty_level  : '无' }}
          </el-col>
          <el-col :span="6" style="font-weight: bold;">
            <span class="box1" >治疗进展</span>：{{ cliDel.progress_name || '无' }}
          </el-col>
          <el-col :span="6" style="font-weight: bold;">
            <span class="box1" >金蝶编码</span>：{{ cliDel.king_no || '无' }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" style="font-weight: bold;">
            <span class="box1">余额显示</span>：{{ cliDel.is_show_balance > 0 ? '是' : '否' }}
          </el-col>
          <el-col :span="6" style="font-weight: bold;">
            <span class="box1">卡项数据</span>：{{ cliDel.card_is_correct > 0 ? '是' : '否' }}
          </el-col>
          <el-col :span="12" style="font-weight: bold;">
            <span class="box1" style="width: 120px;">疤痕类型/位置</span>：{{ cliDel.type_position || '无' }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="font-weight: bold;line-height: 25px;">
              <span  class="box1">备注</span>：{{ cliDel.remarks || '无' }}
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    
      </div>
    </el-card>
    <detailMsgCopy v-if="id " :clienId="id + ''" @clientDetail="clientDetails" ref="detailMsgCopy"/>
    <el-tabs type="card"   v-model="activeName">
      <el-tab-pane label="基础信息" name="first">
        <detailMsg v-if="activeName=='first' && id " :clienId="id + ''" @clientDetail="clientDetails" ref="detailMsg"/>
      </el-tab-pane>
      <el-tab-pane label="消费信息" name="sixth1"  >
        <assetMessage v-if="activeName=='sixth1' && id " :clienId="id + ''"  :detail="cliDel"/>
      </el-tab-pane>
      <el-tab-pane label="病历记录" name="fourteen1" v-if="userInfo.shop_type != 2">
        <medicalCase  v-if="activeName=='fourteen1'"  :clienId="id + ''" :detail ="cliDel"/>
      </el-tab-pane>
      <!-- <el-tab-pane label="转诊单" name="fourteen" >
        <referralList   v-if="activeName=='fourteen' && id " :clienId="id + ''"  :detail="cliDel"/>
      </el-tab-pane> -->
      <el-tab-pane label="订单记录" name="second1">
        <orderRecord  v-if="activeName=='second1'" :clienId="id + ''" :detail ="cliDel"/>
      </el-tab-pane>
      <!-- <el-tab-pane label="收款记录" name="second" v-if="oldId == id">
         <gathering v-if="activeName=='second' && id " :clienId="id + ''" :detail ="cliDel"/>
      </el-tab-pane>
      <el-tab-pane label="销售记录" name="thirdly" v-if="oldId == id">
         <sellRecord v-if="activeName=='thirdly' && id " :clienId="id + ''"  :detail="cliDel"/>
      </el-tab-pane>
       <el-tab-pane label="退款列表" name="fourth" v-if="oldId == id">
         <refundList v-if="activeName=='fourth' && id " :clienId="id + ''" :detail ="cliDel"/>
      </el-tab-pane>
       <el-tab-pane label="退货列表" name="fifth" v-if="oldId == id">
         <refundGoods v-if="activeName=='fifth' && id " :clienId="id + ''" :detail ="cliDel"/>
      </el-tab-pane> -->
      <!-- <el-tab-pane label="服务卡项" name="sixth">
        <serveRecord v-if="activeName=='sixth' && id " :clienId="id + ''" :detail="cliDel"/>
      </el-tab-pane> -->
      <!-- <el-tab-pane label="优惠券" name="seventh" v-if="oldId == id">
        <cardList v-if="activeName=='seventh' && id " :clienId="id + ''" :detail="cliDel"/>
      </el-tab-pane> -->
      <el-tab-pane label="划扣记录" name="seventh" >
        <serveContent  v-if="activeName=='seventh' && id " :clienId="id + ''"  :detail="cliDel"/>
      </el-tab-pane>
      <el-tab-pane label="客访记录" name="eighth" >
        <visitAnswer  v-if="activeName=='eighth' && id " :clienId="id + ''" :consignee="cliDel.customer_name"/>
        <!-- <answerVisit  v-if="activeName=='eighth' && id " :clienId="id + ''" :consignee="cliDel.customer_name"/> -->
      </el-tab-pane>
      <!-- <el-tab-pane label="客保记录" name="ninth" v-if="oldId == id">
        <newList  v-if="activeName=='ninth' && id " :detail="cliDel" :clienId="id + ''" />
      </el-tab-pane> -->
      <el-tab-pane label="案例列表" name="tenth">
        <caseList  v-if="activeName=='tenth' && id " :detail="cliDel" :clienId="id + ''" />
      </el-tab-pane>
      
      <el-tab-pane label="治疗方案" name="twelfth" v-if="isMedical">
        <healPlan   v-if="activeName=='twelfth' && id " :clienId="id + ''" :consignee="cliDel.customer_name"/>
      </el-tab-pane>
      <el-tab-pane label="修复方案" name="eleventh" v-else>
        <repairPlan   v-if="activeName=='eleventh' && id " :clienId="id + ''" :consignee="cliDel.customer_name"/>
      </el-tab-pane>
      <!-- <el-tab-pane label="预存货" name="thirteen" >
        <prestockList   v-if="activeName=='thirteen' && id " :clienId="id + ''" :consignee="cliDel.customer_name"/>
      </el-tab-pane> -->
       <el-tab-pane label="日志记录" name="eleventh1">
        <customerRecord v-if="activeName=='eleventh1' && id "  :clienId="id + ''" :detail="cliDel" />
      </el-tab-pane>
     
    </el-tabs>
  </div>
</template>

<script>
import detailMsg from './components/detailMsg.vue'
import detailMsgCopy from './components/detailMsgCopy.vue'
import serveContent from '../serve/serveContent.vue'
import orderRecord from './orderList.vue'
import customerRecord from './components/customerRecord.vue'
import medicalCase from './medicalCase/index.vue'
import assetMessage from './AssetMessage/index.vue'
import serveRecord from '../serve/serveList.vue'
import cardList from './components/cardList.vue'
import gathering from '../order/proceedsList.vue'
import sellRecord from '../order/orderList.vue'
import refundList from '../order/refundList.vue'
import refundGoods from '../order/refundGoods.vue'
import visitAnswer from './visitAnswer/index.vue'
import answerVisit from './answerVisit.vue'
import newList from '../againVisit/newList.vue'
import caseList from '../case/caseList.vue'
import repairPlan from './repairPlan.vue'
import prestockList from './prestockList.vue'
import referralList from '../order/referralOrderList.vue'
import healPlan from './healPlan.vue'
import { clientDetail,readCustomerId } from "@/api/client";
import { ref } from 'vue';
import { mapGetters } from "vuex";

export default {
  
  name: 'ClientDetail',
  components: {
    detailMsg,
    detailMsgCopy,
    serveContent,
    orderRecord,
    customerRecord,
    assetMessage,
    medicalCase,
    serveRecord,
    cardList,
    sellRecord,
    gathering,
    refundList,
    refundGoods,
    answerVisit,
    visitAnswer,
    newList,
    caseList,
    repairPlan,
    healPlan,
    prestockList,
    referralList
  },
  
  data () {
    return {
      activeName:'first',
      customer_name:'',
      oldId:"",
      id:"",
      cliDel:'',
      pageName:'',
      value1: false,
      ids:[],
      loading:true,
      medicalShop:[73782774881835,73782774991693,73782775085647,73782775131388,73782775206631,73782775392774,73782775377728],
      isMedical:false,
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  mounted () {
    console.log(this.$route.query,"this.$route.query")
    this.oldId = this.$route.query.id.toString()
    this.id = this.$route.query.id.toString()
    this.customer_name = this.$route.query.customer_name
    this.activeName = this.$route.query.activeName;
    this.cliDel = this.$route.query.detail;
    this.pageName = this.$route.query.pageName;
    this.getDetail()
    this.readCustomerId()
  },
  methods: {
    goSon(type,title1,title2){
      const childInstance = this.$refs.detailMsgCopy;
        childInstance[type](title1, title2);

    },
    // 获取详情
    getDetail() {
      console.log(this.id,"this.id");
      clientDetail({ id: this.id }).then(res => {
        this.cliDel = res

        let medicalShop = this.medicalShop;

        this.isMedical  = medicalShop.includes(res.shop_id);
        this.value1 = medicalShop.includes(res.shop_id);
      });
    },
    // 获取同手机号账户
    readCustomerId(){
      readCustomerId({ id: this.id }).then(res => {
        // console.log(res);
        this.ids = res;
      });
    },
    // 参数
      clientDetails(del){
        this.cliDel = del
      },
      // 返回
    back() {
        const query = { search: this.$route.query.search,page:this.$route.query.page}
        this.$router.push({ name: this.$route.query.pageName,query});
      
    },
    changeUser(e){
      let ids = this.ids;
      console.log(e);
      // let clienId = '';
      
      if(e){
        if(ids[1] == undefined){
          this.$message.error('暂无客户信息');
          return false;
        }
        this.id = ids[1];
      }
      if(!e){
        if(ids[2] == undefined){
          this.$message.error('暂无客户信息.');
          return false;
        }
        this.id = ids[2];
      }
      this.getDetail();
      this.$refs.detailMsg.getDetail(this.id);
    }
  }
}
</script>

<style lang="scss" scoped>
.box1{
  display: inline-block;
  width: 70px; text-align-last: justify;color: #666;font-weight: normal;
}
::v-deep .el-tabs__header{
  background: #fff!important;
  padding: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
::v-deep .el-tabs__item{
  font-size: 16px ;
}
::v-deep .el-tabs__item.is-active{
  background:#33bea7;
  color: #fff;
}
::v-deep .el-tabs--card > .el-tabs__header .el-tabs__nav{
  border: none;
}
::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item {
  border: 1px solid #E4E7ED;
  margin-right: 30px;
}
.box-card{
  margin-bottom: 20px ;
  .customer_info{
    font-size: 16px;color: #606266;
    line-height: 36px;
  }
}
.return {
  position: fixed;
  right: 20px;
  top: 71px;
  z-index: 999;
  .backImg {
    margin-right: 14px;
    width: 32px;
    height: 100%;
    cursor: pointer;
    vertical-align: middle;
  }
}
.switch{
  width: 100%;
  height: 40px;
  z-index: 999;
}
</style>
